export default __webpack_public_path__ + "static/media/speechRestTimeStart.fd50ce99.mp3";